import styled from 'styled-components';

export const LkContainerUI = styled.div`
  max-width: 1240px;
  margin: 0 auto;

  display: flex;
  justify-content: flex-start;
  gap: 20px;
  flex-direction: row;
`;

export const LkNavbarOthersContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 120px;
  padding-right: 20px;
  width: 100%;

  .breadcrumbs {
    li {
      a {
        color: #7594b9;
        text-decoration: underline;
      }

      &:last-child {
        a {
          text-decoration: none;
          color: #444;
        }
      }
    }
  }
`;
